import { canUseDOM } from "./utils";

export const pushToDataLayer = (data) => {
  if (canUseDOM) {
    window.dataLayer.push(data);
  }
};
